// extracted by mini-css-extract-plugin
export var buttonContainer = "_9p-1";
export var fontSizeSelect = "_9p-3";
export var formatSelect = "_9p-2";
export var formats = "_9p-4";
export var hidden = "_9p-5";
export var icon = "_9p-6";
export var select = "_9p-0";